import { call, put, select, takeLatest } from 'redux-saga/effects'
import { StateCustomDataConstants } from '../store/nemsisCustomData.constants'
import { setCustomDisplayData } from '../store/nemsisCustomData.actions'
import { throwPcrException } from '../../pcr/store/pcr.actions'
import { performWithMutexHOG } from '../../../services/mutexUtility.service'
import { deleteGroups, createProcedureVitalGroups, arrangeGroupsByTimeline } from '../utils/customElements.util'
import { getPatientTimelineSelector } from '../../timeline/selectors/patientTimeline.selector'
import { ITimelineState } from '../../timeline/store/timeline.types'
import { INemsisCustomDataOptions } from '../../options/store/options.types'
import { getNemsisCustomDataOptionsSelector } from '../../options/selectors'
import { ICustomTimeLineItems, IStateCustomDataDisplayState } from '../store/nemsisCustomData.types'
import { getStateCustomDisplayDataSelector } from '../selectors/stateCustomDisplayData.selector'
import { getServiceIdSelector } from '../../user/selectors'
import { getPcrIdSelector } from '../../home/selectors'
import { PcrDocsService } from '../../../services/pcrDocs.service'
import { IPcr } from '../../pcr/store/pcr.types'

export function* updateGroupsFromTimeline() {
  try {
    const nemsisCustomDataOptions: INemsisCustomDataOptions = yield select(getNemsisCustomDataOptionsSelector)
    const { customDataWithState, customConfigGroupOptions } = nemsisCustomDataOptions

    const customDisplayData: IStateCustomDataDisplayState = yield select(getStateCustomDisplayDataSelector)
    const { stateCustomElements, updateAction, deleteMedicationKey } = customDisplayData
    const patientTimeline: ITimelineState = yield select(getPatientTimelineSelector)
    const serviceId: string = yield select(getServiceIdSelector)
    const pcrID: string = yield select(getPcrIdSelector)
    const pcrDocsService = new PcrDocsService(serviceId)
    const pcrDoc: IPcr = yield call([pcrDocsService, pcrDocsService.getPCR], pcrID)
    const medicationAdministeredStateList = pcrDoc.patient.medicationAdministeredStateList
    const { items } = patientTimeline
    const updatedItems: ICustomTimeLineItems = items.flatMap((item) => {
      if (item.itemType === 'Medications') {
        const med = medicationAdministeredStateList.find((med) => med.key === item.key)
        if (med) {
          return med.addMedicationAdministeredData.map((addMedData) => ({
            ...item,
            key2: addMedData.key,
          }))
        }
      }

      return item
    })

    if (updateAction === StateCustomDataConstants.ADD_TIMELINE_GROUP) {
      const newGroupData = createProcedureVitalGroups(
        updatedItems,
        customDataWithState,
        stateCustomElements,
        customConfigGroupOptions
      )
      yield put(setCustomDisplayData(newGroupData))
    } else if (updateAction === StateCustomDataConstants.REORDER_TIMELINE_GROUP) {
      const sortTimeLineItems = updatedItems.sort((a, b) => new Date(a.date).getTime() - new Date(b.date).getTime())
      const updatedCustomElements = arrangeGroupsByTimeline(stateCustomElements, sortTimeLineItems)
      yield put(setCustomDisplayData(updatedCustomElements))
    } else if (
      updateAction === StateCustomDataConstants.REMOVE_TIMELINE_GROUP ||
      updateAction === StateCustomDataConstants.REMOVE_MEDICATION_GROUP
    ) {
      const isMedicationGroup = updateAction === StateCustomDataConstants.REMOVE_MEDICATION_GROUP
      const filterItems =
        isMedicationGroup && deleteMedicationKey
          ? updatedItems?.filter((item) => item?.key2 !== deleteMedicationKey)
          : updatedItems

      const stateCustomDataAfterDeletion = deleteGroups(filterItems, stateCustomElements)
      yield put(setCustomDisplayData(stateCustomDataAfterDeletion))
    }
  } catch (e) {
    yield put(throwPcrException(`updateGroupsFromTimelineSaga() error: ${e}`))
  }
}

export function* updateGroupsFromTimelineSaga() {
  yield takeLatest(
    [StateCustomDataConstants.UPDATE_GROUPS_FROM_TIMELINE],
    performWithMutexHOG,
    updateGroupsFromTimeline
  )
}
